import { Breadcrumb, Button, Card, Divider, Form, Input, Modal } from "antd";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import ProfileService from "../../services/profile.service";
import { ReactComponent as TitleIcon } from "../../assests/icons/changePassword.svg";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { CONFIG } from "../../environment";
import OTP from "../../components/otp";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormdata] = useState([]);
  const [otpEnabled, setOtpEnabled] = useState(true);
  const [stage, setStage] = useState(1);
  const [form] = Form.useForm();
  const [message, setMessage] = useState("");
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const { t } = useTranslation();
  const renderChangePasswordStage = () => {
    switch (stage) {
      case 1:
        return renderForm();
      case 2:
        return (
         
            <Card className="col-12  ">
              <OTP
                otp={otp}
                setOtp={setOtp}
                onConfirm={(values) => onChangePassword({ ...formData, ...values })}
                handleResendOtp={() => changePasswordVerify(formData)}
                cancelTransaction={() => {
                  setStage(1);
                  setFormdata({});
                }}
              />
            </Card>
          )
        

      default:
        return renderForm();
    }
  };

  const changePasswordVerify = async (values) => {
    try {
      setFormdata(values);
      setLoading(true);
      const response = await ProfileService.changePasswordVerify({
        newPassword: values?.newPassword,
        currentPassword: values?.oldPassword,
      });
      if (response.status === 200) {
        setLoading(false);
        setOtpEnabled(response.data["otpEnable"]);
        if (response.data["otpEnable"] === true) {
          setStage(2);
        } else {
          await onChangePassword({ ...values, otp: CONFIG?.DEFAULT_OTP });
        }
      }
    } catch (err) {}
  };
  const onChangePassword = async (values) => {
    try {
      const request = {
        newPassword: formData?.newPassword,
        currentPassword: formData?.oldPassword,
        otp: values.otp,
        enabledTOTP:values.enabledTOTP,
      };
      setLoading(true);
      const response = await ProfileService.changePassword(request);
      if (response.status === 200) {
        setLoading(false);
        setMessage(response.data["message"]);
        setSuccessVisible(true);
      }
    } catch (error) {
      setLoading(false);
      setOtp("");
    }
  };

  function renderForm() {
    return (
      <>
        <Card>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-5">
              <Form
                form={form}
                name="ChangePassordForm"
                layout="vertical"
                onFinish={changePasswordVerify}
              >
                <Form.Item
                  label={t("pages.changePassword.current_password", {
                    defaultValue: "Current Password",
                  })}
                  name="oldPassword"
                  rules={[
                    { required: true, 
                      message: t("errorMesssages.current_password_required", {
                        defaultValue: "Current Password is required",
                      }),
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder={t("pages.changePassword.current_password", {
                      defaultValue: "Current Password",
                    })}
                    minLength={CONFIG?.PASSWORD_MIN_LENGTH}
                    maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
                  />
                </Form.Item>
                <Form.Item
                  label={t("pages.forcePassword.new_password", {
                    defaultValue: "New Password",
                  })}
                  name="newPassword"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(
                        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@#&*!])[A-Za-z\d@#&*!]{8,}$/
                      ),
                      message: t("errorMesssages.new_password_criteria", {
                        defaultValue:
                          "New Password should match Password Criteria!",
                      }),
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("oldPassword") !== value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          t("errorMesssages.new_pass_valid", {
                            defaultValue:
                              "New Password should not same as Current Password",
                          })
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
                    size="large"
                    placeholder={t("pages.forcePassword.new_password", {
                      defaultValue: "New Password",
                    })}
                    minLength={CONFIG?.PASSWORD_MIN_LENGTH}
                  />
                </Form.Item>
                <Form.Item
                  label={t("pages.forcePassword.confirm_new_password", {
                    defaultValue: "Confirm New Password",
                  })}
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: t(
                        "errorMesssages.confirm_new_password_required",
                        {
                          defaultValue: "Confirm New Password is required",
                        }
                      ),
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          t("errorMesssages.password_do_not_match", {
                            defaultValue: "Passwords do not match!",
                          })
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    size="large"
                    maxLength={CONFIG?.PASSWORD_MAX_LENGTH}
                    placeholder={t("pages.forcePassword.confirm_new_password", {
                      defaultValue: "Confirm New Password",
                    })}
                    minLength={CONFIG?.PASSWORD_MIN_LENGTH}
                  />
                </Form.Item>
                <Button
                  style={{ marginTop: 10, marginBottom: 10 }}
                  block
                  size="large"
                  className="solid-btn-style"
                  type="primary"
                  htmlType="submit"
                >
                  {t("buttons.submit_btn", {
                    defaultValue: "Submit",
                  })}
                </Button>
              </Form>

              <Button
                onClick={() => {
                  setMessage("");
                  form.resetFields();
                }}
                style={{ margin: "0 auto", display: "block" }}
                type="link"
              >
                {t("buttons.clear_btn", {
                  defaultValue: "Clear",
                })}
              </Button>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-7">
              <Card className="application-card mx-3">
                <div className="password-criteria">
                  <h5 className="primary-title">
                    {t("pages.changePassword.tips", {
                      defaultValue: "New Password Criteria Tips",
                    })}
                  </h5>
                  <div className="change-list">
                    <ul className="my-3 mx-3 ">
                      <li className="mb-2">
                        {t("pages.changePassword.Password_length", {
                          defaultValue:
                            "Password length should not be less than 6 and not more than 16 characters.",
                        })}
                      </li>
                      <li className="mb-2">
                        {t("pages.changePassword.password_allow", {
                          defaultValue:
                            "Password should contain at least one digit [0-9], one alphabet [A-Z] [a-z] and one special character such as  [@#&*!].",
                        })}
                      </li>
                      <li className="mb-2">
                        {t("pages.changePassword.password_avoid", {
                          defaultValue:
                            "Please avoid choosing a password that is generic in nature, guessable or inferable.",
                        })}
                      </li>
                      <li className="mb-2">
                        {t("pages.changePassword.password_avoid_relate", {
                          defaultValue:
                            "Avoid password that is related to your personal data such as name, date of birth, address, telephone number and car or bike registration number.",
                        })}
                      </li>
                      <li className="mb-2">
                        {t("pages.changePassword.password_memorize", {
                          defaultValue:
                            "It is a good practice to memorize your password rather than write it down somewhere.",
                        })}
                      </li>
                      <li>
                        {t("pages.changePassword.security_reasons", {
                          defaultValue:
                            "For security reasons, keep changing your password at regular intervals.",
                        })}
                      </li>
                    </ul>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </Card>
      </>
    );
  }

  return (
    <>
        {/* <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.change_pass", {
                defaultValue: "Change Password",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb> */}

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon
              height={30}
              style={{ marginRight: "5px", borderRadius: "100%" }}
            /> */}
            <h3 className="title mb-0">
              {t("navigation.change_pass", {
                defaultValue: "Change Password",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="application-card">
        <div>{renderChangePasswordStage()}</div>
      </Card>
      <Modal
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{   margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/dashboard");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
